"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopCell = void 0;
var GameManager_1 = require("./../../../GameManager");
var Utils_1 = require("../../../utils/Utils");
var BoardManager_1 = require("../BoardManager");
var GameVars_1 = require("../../../GameVars");
var GameConstants_1 = require("../../../GameConstants");
var AudioManager_1 = require("../../../AudioManager");
var ShopCell = /** @class */ (function (_super) {
    __extends(ShopCell, _super);
    function ShopCell(scene, i) {
        var _this = _super.call(this, scene) || this;
        _this.i = i;
        var background = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "shop_cell");
        _this.add(background);
        _this.buyButton = new Utils_1.Button(_this.scene, 150, -2, "texture_atlas_1", "btn_buy_off", "btn_buy_on");
        _this.buyButton.onDown(_this.onClickBuy, _this);
        _this.add(_this.buyButton);
        _this.nameLabel = new Phaser.GameObjects.Text(_this.scene, 10, -30, "", { fontFamily: "Baloo", fontSize: "22px", color: "#FFFFFF", align: "center" });
        _this.nameLabel.setOrigin(.5);
        _this.nameLabel.setWordWrapWidth(180);
        _this.nameLabel.lineSpacing = -5;
        _this.nameLabel.setStroke("#703E25", 6);
        _this.add(_this.nameLabel);
        _this.priceLabel = new Phaser.GameObjects.Text(_this.scene, 10, 20, "", { fontFamily: "Baloo", fontSize: "45px", color: "#FFD445" });
        _this.priceLabel.setOrigin(.5);
        _this.priceLabel.setStroke("#703E25", 8);
        _this.add(_this.priceLabel);
        var textureAtlas;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureAtlas = "texture_atlas_2";
        }
        else {
            textureAtlas = "texture_atlas_3";
        }
        _this.itemImage = new Phaser.GameObjects.Image(_this.scene, -130, 0, textureAtlas);
        _this.add(_this.itemImage);
        _this.lockedItemImage = new Phaser.GameObjects.Image(_this.scene, _this.itemImage.x, _this.itemImage.y, "texture_atlas_1", "uncovered_item_icon");
        _this.lockedItemImage.visible = false;
        _this.add(_this.lockedItemImage);
        _this.newTab = new Phaser.GameObjects.Image(_this.scene, -144, -28, "texture_atlas_1", "new_tab");
        _this.newTab.visible = GameVars_1.GameVars.modeGameData.itemsPurchased[i + GameVars_1.GameVars.modeGameData.restartCounter + 1].isNew;
        _this.add(_this.newTab);
        _this.reset(_this.i);
        return _this;
    }
    ShopCell.prototype.update = function () {
        if (this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1 <= GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4) {
            if (GameVars_1.GameVars.shopItemsPrices[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1] * (1 + GameVars_1.GameVars.modeGameData.itemsPurchased[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].count * GameConstants_1.GameConstants.SHOW_INCREMENT_PERCENTAGE) > GameVars_1.GameVars.modeGameData.coins && this.buyButton.input.enabled) {
                this.buyButton.setAlpha(.2);
                this.buyButton.input.enabled = false;
            }
            else if (GameVars_1.GameVars.shopItemsPrices[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1] * (1 + GameVars_1.GameVars.modeGameData.itemsPurchased[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].count * GameConstants_1.GameConstants.SHOW_INCREMENT_PERCENTAGE) <= GameVars_1.GameVars.modeGameData.coins && !this.buyButton.input.enabled) {
                this.buyButton.setAlpha(1);
                this.buyButton.input.enabled = true;
            }
        }
    };
    ShopCell.prototype.reset = function (i) {
        this.i = i;
        // if (true) {
        if (this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1 <= GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4) {
            this.buyButton.alpha = 1;
            this.buyButton.setInteractive();
            this.itemImage.visible = true;
            this.lockedItemImage.visible = false;
            this.nameLabel.visible = true;
            var textureName = void 0;
            if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
                textureName = "cake_" + (this.i + GameVars_1.GameVars.modeGameData.restartCounter + 2);
            }
            else {
                textureName = "biscuits_" + (this.i + GameVars_1.GameVars.modeGameData.restartCounter + 2);
            }
            this.itemImage.setFrame(textureName);
            var size = Math.sqrt(this.itemImage.width * this.itemImage.height);
            var maxSize = void 0;
            if (size < 150) {
                maxSize = 60;
            }
            else if (size < 200) {
                maxSize = 70;
            }
            else if (size < 250) {
                maxSize = 85;
            }
            else if (size < 300) {
                maxSize = 95;
            }
            else {
                maxSize = 110;
            }
            this.itemImage.setScale(maxSize / this.itemImage.height);
            this.priceLabel.text = GameVars_1.GameVars.formatNumber(GameVars_1.GameVars.shopItemsPrices[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1] * (1 + GameVars_1.GameVars.modeGameData.itemsPurchased[i + GameVars_1.GameVars.modeGameData.restartCounter + 1].count * GameConstants_1.GameConstants.SHOW_INCREMENT_PERCENTAGE));
            this.newTab.visible = GameVars_1.GameVars.modeGameData.itemsPurchased[i + GameVars_1.GameVars.modeGameData.restartCounter + 1].isNew;
            this.nameLabel.text = GameVars_1.GameVars.cakesNames[GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "MODE_1" : "MODE_2"][this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].toUpperCase();
            this.nameLabel.setFontSize(this.nameLabel.text.length > 20 ? 18 : 22);
        }
        else {
            this.buyButton.alpha = .2;
            this.buyButton.disableInteractive();
            this.itemImage.visible = false;
            this.lockedItemImage.visible = true;
            this.priceLabel.text = "???";
            this.nameLabel.visible = false;
            if (this.newTab) {
                this.newTab.visible = false;
            }
        }
    };
    ShopCell.prototype.hideNews = function () {
        if (GameVars_1.GameVars.modeGameData.itemsPurchased[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].isNew && this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1 <= GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4) {
            GameVars_1.GameVars.modeGameData.itemsPurchased[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].isNew = false;
            GameManager_1.GameManager.writeGameData();
        }
    };
    ShopCell.prototype.onClickBuy = function () {
        GameVars_1.GameVars.modeGameData.itemsPurchased[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].isNew = false;
        this.newTab.visible = false;
        BoardManager_1.BoardManager.onItemPurchased(this.i + GameVars_1.GameVars.modeGameData.restartCounter + 2);
        this.priceLabel.text = GameVars_1.GameVars.formatNumber(GameVars_1.GameVars.shopItemsPrices[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1] * (1 + GameVars_1.GameVars.modeGameData.itemsPurchased[this.i + GameVars_1.GameVars.modeGameData.restartCounter + 1].count * GameConstants_1.GameConstants.SHOW_INCREMENT_PERCENTAGE));
        AudioManager_1.AudioManager.playSound("click_button");
        GameManager_1.GameManager.writeGameData();
    };
    return ShopCell;
}(Phaser.GameObjects.Container));
exports.ShopCell = ShopCell;
